export default "__VITE_PUBLIC_ASSET__42f23b42__"